

module.exports = __webpack_require__.stylable.create(
    "MonthlyHeaders3842048275",
    {"classes":{"root":"MonthlyHeaders3842048275__root"},"vars":{},"stVars":{"DefaultFont":"\"{theme: 'Body-M', size:'14px', lineHeight: '1.4em'}\"","Color":"\"fallback(color(--weekDaysColor), fallback(color(--daysColor), color(color-5)))\"","Font":"\"fallback(font(--weekDaysFont), font({theme: 'Body-M', size:'14px', lineHeight: '1.4em'}))\"","Mobile_monthlyWeekdaysFontSize":"'\"unit(fallback(--mobile_monthlyWeekdaysFontSize, 12), px)\"'"},"keyframes":{}},
    "",
    2,
    "MonthlyHeaders3842048275",
    null
);
